/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import * as openapi_graph from './openapi_graph';
import * as graph from './graph';

export type Int64 = string | number;

export interface GetGraphSlotsReq {
  spaceID: string;
  graphUID: string;
  psm: string;
  isBOE?: boolean;
  env?: string;
  cluster?: string;
  /** FornaxSDK 鉴权  */
  Authorization?: string;
}

export interface GetGraphSlotsResp {
  nodeSlots: Array<openapi_graph.NodeWithSlots>;
  /** 打点, 跟进问题使用 */
  slotSetVersion?: string;
}

export interface GetNodeSlotsReq {
  spaceID: string;
  graphUID: string;
  nodeUID: string;
  psm: string;
  isBOE?: boolean;
  env?: string;
  cluster?: string;
  /** FornaxSDK 鉴权  */
  Authorization?: string;
}

export interface GetNodeSlotsResp {
  slots: Array<openapi_graph.Slot>;
  nodeType: graph.NodeType;
  /** 打点, 跟进问题使用 */
  slotSetVersion?: string;
}
/* eslint-enable */
